import React from "react";
import Modal from "react-bootstrap/Modal";
import LoadingButton from "../../chatbotSettings/components/loadingButton";
import Button from "../../chatbotSettings/components/button";

const EnableModal = (props) => {
  const {
    isEnabling,
    show,
    handleClose,
    icon,
    selectedItem,
    handleEnableItem,
  } = props;

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="chatbot-settings-remove-modal-container"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeLabel="close" closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            <div className="d-flex flex-column gap-0">
              <span style={{ fontSize: "18px" }}>{selectedItem?.isEnable ? 'Are you sure to disable this schedule?' : 'Are you sure to enable this schedule?'}</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-item-center align-self-center gap-2">
            <div>{icon}</div>
            <div>
              <span style={{ fontSize: "14px" }}>
                {selectedItem !== null ? selectedItem.subject : ""}
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex gap-2">
            <Button
              label="Cancel"
              handleClickBtn={handleClose}
              disabled={isEnabling}
            />
            <LoadingButton
              label={selectedItem?.isEnable ? "Disable" : "Enable"}
              handleClickBtn={() =>
                handleEnableItem(selectedItem !== null ? selectedItem._id : "", selectedItem?.isEnable ? false : true)
              }
              isLoading={isEnabling}
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EnableModal;
